module["exports"] = [];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/name/prefix.js
// module id = 1806
// module chunks = 0